import * as React from "react";
const IconXrp = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 65 65"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M46.9 62.7c-5.1 0-10-2.6-12.7-7.2-2.2-3.7-2.6-8-1.1-12 .4-1.2.3-2.8-.6-3.4-1-.6-2.5.1-3.3 1.1-2.8 3.1-6.8 4.9-11 4.9-8.1 0-14.7-6.5-14.7-14.4S10 17.3 18.1 17.3c4.6 0 9 2.2 11.8 5.8.5.7 1.5 1.3 2.3 1 .9-.4 1.2-1.9.8-3.1-1.3-3.9-.8-8.1 1.3-11.7 4-6.9 13-9.2 20-5.3 3.4 1.9 5.9 5.1 6.9 8.8s.5 7.6-1.5 10.9c-2.3 3.9-6.2 6.4-10.7 7-1 .3-2 1-2 1.8s1 1.5 1.9 1.6c4.5.6 8.4 3.2 10.7 7 2 3.3 2.5 7.2 1.5 10.9-1 3.8-3.4 6.9-6.9 8.8-2.3 1.3-4.8 1.9-7.3 1.9M31.7 35.4c1.1 0 2.1.3 3.1.9 3 1.9 3.6 5.8 2.5 8.7-1 2.7-.7 5.7.8 8.2 2.8 4.8 9.1 6.4 13.9 3.6 2.4-1.3 4-3.5 4.7-6.1.7-2.5.3-5.2-1-7.4-1.6-2.7-4.3-4.5-7.4-4.9-3.3-.4-5.8-3-5.8-6s2.5-5.6 5.8-6c3.1-.4 5.9-2.2 7.4-4.9 1.3-2.3 1.7-4.9 1-7.4C56 11.5 54.3 9.4 52 8c-4.9-2.7-11.1-1-13.9 3.7-1.4 2.4-1.7 5.3-.9 8 1 3.2.1 7.3-3.3 8.7-2.6 1.1-5.7 0-7.6-2.5s-5-4-8.2-4c-5.6 0-10.2 4.4-10.2 9.9s4.6 9.9 10.2 9.9c2.9 0 5.7-1.2 7.7-3.4 1.4-1.7 3.6-2.9 5.9-2.9" />
  </svg>
);
export default IconXrp;
